<template>
  <div>
    <ContentHeader title="Bonus" />
    <table-skeleton v-if="loading"/>
    <section v-else class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="card-tools">
                  <div class="d-flex filter-container">
                    <select
                      class="form-select mr-3 w-25 select-perpage"
                      v-model="table.perPage"
                    >
                      <option value="5">5</option>
                      <option value="10" selected>10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                    <input
                      type="text"
                      name="search"
                      class="form-control w-75 search-bar"
                      placeholder="Search"
                      v-model="table.filter"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  responsive
                  :items="table.items"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                  <template #cell(amount)="data">
                    <div style="min-width:150px !important;">{{ datakoma(data.value) }}</div>
                  </template>
                  <template #cell(created_at)="data">
                    <div style="min-width:200px !important;">{{ dateTime(data.value)}}</div>
                  </template>
                  <template #cell(status)="data">
                    <div class="btn btn-warning rounded-pill" v-if="data.value == 'PENDING'">
                      PENDING
                    </div>
                    <div class="btn btn-success rounded-pill" v-else-if="data.value == 'INSTALLED'">
                      INSTALLED
                    </div>
                    <div class="btn btn-danger rounded-pill" v-else-if="data.value == 'EXPIRED'">
                      EXPIRED
                    </div>
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiVendor from "../services/VendorApiServices";
import TableSkeleton from '../components/loading-screen/TableSkeleton.vue';
import moment from "moment";

export default {
  components: {
    ContentHeader,
    TableSkeleton,
  },
  data() {
    return {
      loading: true,
      bonus: [],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {key:'broker.name', label: 'Broker Name',sortable: true},
          {key:'amount', label: 'Rebate Amount',sortable: true},
          {key:'created_at',label: 'Rebate Periode',sortable: true},
          {key:'status',label: 'Status',sortable: true}
          // "Action",
        ],
        items:[],
      },
    };
  },
  async mounted() {
    try {
      let response = await apiVendor.get(`${this.$user_id}/rebates/`)
      this.table.items = response.data.data 
      this.table.totalRows = this.table.items.length
      this.loading = false
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.response.data.data.massage,
        "error"
      );
    } finally {
      this.loading = false
    }
  },
  methods: {
    dateTime(value) {
      return moment(value).format('DD MMMM YYYY');
    },
    datakoma(data){
      return data.toFixed(2)
    },
    changeStatus(id) {
      const index = this.subscriptions.findIndex((item) => item.id == id);
      if (this.subscriptions[index].status === 'PENDING') {
        this.subscriptions[index].status = 'INSTALLED'
      } else if(this.subscriptions[index].status === 'INSTALLED') {
        this.subscriptions[index].status = 'EXPIRED'
      } else {
        this.subscriptions[index].status = 'PENDING'
      }
    },
  },
};
</script>
